import { factory } from "@cems-eco/core/src/utils/platform";
import DetailsComponent from "./details/details.vue";
import WebParts from "./parts/parts.web.vue";
import MobileParts from "./parts/parts.mobile.vue";
import WebFilter from "./filter/filter.web.vue";
import MobileFilter from "./filter/filter.mobile.vue";
import CustomFieldComponent from "@/components/custom-field/custom-field.vue";


export default factory({
    web: {
        DetailsComponent,
        PartsComponent: WebParts,
        FilterComponent: WebFilter,
        CustomField: CustomFieldComponent,
    },
    mobile: {
        DetailsComponent,
        PartsComponent: MobileParts,
        FilterComponent: MobileFilter,
        CustomField: CustomFieldComponent,
    },
}) as any; 
